import { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyTitle } from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';
import { cva } from 'class-variance-authority';

const pageFeedbackIconVariants = cva('pb-4 text-3xl', {
	variants: {
		variant: {
			default: 'text-foreground-body',
			success: 'text-success',
			destructive: 'text-danger',
		},
	},
	defaultVariants: { variant: 'default' },
});

const PageFeedback = ({ icon, title, text, actions, variant, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('border p-4 text-left', className);
	const iconClassName = pageFeedbackIconVariants({ variant });

	// Render
	return (
		<Empty className={rootClassName}>
			<EmptyContent>
				{icon && (
					<EmptyMedia className={iconClassName}>
						<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
					</EmptyMedia>
				)}
				{title && <EmptyTitle>{title}</EmptyTitle>}
				{text && <EmptyDescription>{text}</EmptyDescription>}
			</EmptyContent>
			{actions && <EmptyActions className='flex-start'>{actions}</EmptyActions>}
		</Empty>
	);
};
export { PageFeedback };
